import { Grid } from '@mui/material';
import React, { FC } from 'react';
import { FieldArrayWithId } from 'react-hook-form';

import EmptyState from './empty-state';
import ListItemElement from './list-items-element';
import SectionItemTitle from './container-items';

type DeleteConfig = {
  func: (...args: any[]) => void;
  params: Record<string, any>;
  message: string;
  title: string;
};

type ContactInfoSectionProps = {
  title: string;
  fields: FieldArrayWithId<any, any, any>[];
  onOpenModal: () => void;
  isDeleteLoading: boolean;
  getItemTitle: (field: any) => string;
  getItemValue: (field: any) => string;
  getDeleteConfig: (field: any) => DeleteConfig;
  disabledDelete?: (field: any) => boolean;
  dispatchDelete: (action: any) => void;
};

const ContactInfoSection: FC<ContactInfoSectionProps> = ({
  title,
  fields,
  onOpenModal,
  isDeleteLoading,
  getItemTitle,
  getItemValue,
  getDeleteConfig,
  disabledDelete,
  dispatchDelete,
}) => (
  <Grid item>
    <SectionItemTitle title={title} onClickIcon={onOpenModal}>
      {fields.length > 0 ? (
        fields.map((f) => {
          const deleteConfig = getDeleteConfig(f);
          return (
            <ListItemElement
              key={f._id}
              title={getItemTitle(f)}
              value={getItemValue(f)}
              disabledButton={isDeleteLoading}
              disabledDelete={disabledDelete?.(f)}
              onclickIcon={() => {
                dispatchDelete({
                  type: 'delete',
                  data: {
                    func: deleteConfig.func,
                    params: deleteConfig.params,
                  },
                  message: deleteConfig.message,
                  title: deleteConfig.title,
                });
              }}
            />
          );
        })
      ) : (
        <EmptyState />
      )}
    </SectionItemTitle>
  </Grid>
);

export default ContactInfoSection;
